import { Popover } from "antd";
import PopoverMenu from "app/components/PopoverMenu";
import UserInfo from "app/components/UserInfo";
import { EMPTY_VALUE, STORAGE } from "constant";
import { useSetValue } from "hook";
import { IProfileAuthOutputModel } from "interfaces";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OtherUtil } from "utils/other";
import { StorageUtil } from "utils/storage";
import "./Header.style.scss";
import { PUBLIC_ROUTE } from "constant/routes/page";

type P_Props = {
  title: string;
};

const HeaderPresenter = (props: P_Props) => {
  const navigate = useNavigate();
  const [profile, setProfile] = useSetValue<IProfileAuthOutputModel>();

  useEffect(() => {
    const profileLocal: IProfileAuthOutputModel = JSON.parse(localStorage.getItem(STORAGE.LOCAL_PROFILE) || '""');
    if (profileLocal) {
      setProfile(profileLocal);
    }

    // eslint-disable-next-line
  }, []);

  const handleLogout = () => {
    StorageUtil.removeItem(STORAGE.LOCAL_ACCESS_TOKEN);
    StorageUtil.removeItem(STORAGE.LOCAL_PATH_NAME);
    StorageUtil.removeItem(STORAGE.LOCAL_PROFILE);
    StorageUtil.removeItem(STORAGE.LOCAL_REFRESH_TOKEN);
    StorageUtil.removeItem(STORAGE.SESSION_CURRENT_DATE);

    navigate(PUBLIC_ROUTE.LOGIN);
  };

  return (
    <div className="header">
      <div className="header__title">{props.title}</div>
      <Popover
        trigger={"click"}
        content={
          <PopoverMenu>
            <div className="c-pointer" onClick={handleLogout}>
              Đăng xuất
            </div>
          </PopoverMenu>
        }
      >
        <UserInfo
          src={profile?.avatar || null}
          title={OtherUtil.getFullname(profile?.firstName, profile?.lastName) || EMPTY_VALUE}
          subTitle={profile?.email || EMPTY_VALUE}
        />
      </Popover>
    </div>
  );
};

export default HeaderPresenter;
